<template>
  <div class="stepOne" v-if='token'>
    <div class="searchCriteria">
      <!-- 归属地及号码输入框 -->
      <div class="searchCityAndNum">
        <div class="searchCity">
          <span class="searchTitle">号码归属地：</span>
          <span  class="searchCon">
            <el-cascader size="medium" ref="cascader" :options="cityList" v-model="cityDefault" @change="cityChange(cityDefault)" :props="{value: 'code',label: 'name',children: 'city',expandTrigger: 'hover',checkStrictly: true}"></el-cascader>
          </span>
        </div>
        <div class="searchNum">
          <el-input
            ref="licknuminp"
            size="medium"
            :placeholder="minlengthdesc"
            :maxlength="maxlength"
            :minlength="minlength"
            v-model="licknum"
            clearable>
          </el-input>
          <el-button size="medium" class="searchBtn" type="primary" @click="searchBtnFun()">搜索</el-button>
        </div>
      </div>
      
      <div class="searchSecondList" v-if="upOrdown">
        <!-- 搜索方式 -->
        <div class="searchSecondItem" >
          <span class="searchTitle">{{searchWay.searchTitle}}：</span>
          <span class="searchCon">
            <span class="searchConItem cursor" v-for="(item,index) in searchWay.searchCon" :dataid="item.code" :class="{searchConItemAct:item.code==searchWayIndex}" :key="index"  @click="changesearchWayIndex(item.code,$event)" size="small">{{item.name}}</span>
          </span>
        </div>
        <!-- 号段搜索 -->
        <div class="searchSecondItem" >
          <span class="searchTitle">{{haoduanSearch.searchTitle}}：</span>
          <span class="searchCon">
            <span class="searchConItem cursor" v-for="(item,index) in haoduanSearch.searchCon" :dataid="item" :key="index"  @click="changehaoduanSearchIndex(item,$event)" size="small">{{item}}</span>
          </span>
        </div>
        <!-- 号码等级 -->
        <div class="searchSecondItem" >
          <span class="searchTitle">{{haoduanLevel.searchTitle}}：</span>
          <span class="searchCon">
            <span class="searchConItem cursor" v-for="(item,index) in haoduanLevel.searchCon" :dataid="item.code" :class="{searchConItemAct:item.code==haoduanLevelIndex}" :key="index"  @click="changehaoduanLevelIndex(item.code)" size="small">{{item.name}}</span>
          </span>
        </div>
        <!-- 特殊靓号 -->
        <div class="searchSecondItem" >
          <span class="searchTitle">{{specialNum.searchTitle}}：</span>
          <span class="searchCon">
            <span class="searchConItem cursor" v-for="(item,index) in specialNum.searchCon" :dataid="item.code" :class="{searchConItemAct:item.code==specialNumIndex}" :key="index"  @click="changespecialNumIndex(item.code)" size="small">{{item.name}}</span>
          </span>
        </div>
      </div>
      <!-- 高级靓号 -->
      <div class="searchThirdItem" v-if="upOrdown">
        <div class="searchTitle">{{searchlianghaoList.searchTitle}}：</div>
        <div class="searchCon">
          <span class="searchConItem cursor" v-for="(item,index) in searchlianghaoList.searchCon" :dataid="item.code" :class="{searchConItemAct:item.code==lianghaoCondition}" :key="index"  @click="changelianghaoCondition(item.code)" size="small">{{item.name}}</span>
        </div>
      </div>
      <!-- 普通靓号 -->
      <div class="searchThirdItem" v-if="upOrdown">
        <div class="searchTitle">{{searchpuhaoList.searchTitle}}：</div>
        <div class="searchCon">
          <span class="searchConItem cursor" v-for="(item,index) in searchpuhaoList.searchCon" :dataid="item.code" :class="{searchConItemAct:item.code==puhaoCondition}" :key="index"  @click="changepuhaoCondition(item.code)" size="small">{{item.name}}</span>
        </div>
      </div>
      <!-- 价格区间 -->
      <div class="searchThirdItem" v-if="upOrdown">
        <div class="searchTitle">{{priceInterval.searchTitle}}：</div>
        <div class="searchCon">
          <span class="searchConItem cursor" v-for="(item,index) in priceInterval.searchCon" :dataid="item.code" :class="{searchConItemAct:item.code==priceIntervalIndex}" :key="index"  @click="changepriceInterval(item.code)" size="small">{{item.name}}</span>
        </div>
      </div>
      <!-- 较多数位 -->
      <div class="searchThirdItem" v-if="upOrdown">
        <div class="searchTitle">{{jiaoduoshuwei.searchTitle}}：</div>
        <div class="searchCon">
          <span class="searchConItem cursor" v-for="(item,index) in jiaoduoshuwei.searchCon" :dataid="item.code" :class="{searchConItemAct:item.code==jiaoduoshuweiIndex}" :key="index"  @click="changejiaoduoshuwei(item.code)" size="small">{{item.name}}</span>
        </div>
      </div>
      <!-- 不含数位 -->
      <div class="searchThirdItem" v-if="upOrdown">
        <div class="searchTitle">{{buhanshuwei.searchTitle}}：</div>
        <div class="searchCon">
          <span 
            class="searchConItem cursor" 
            v-for="(item,index) in buhanshuwei.searchCon" 
            :dataid="item.code" 
            :class="{searchConItemAct:item.code==buhanshuweiIndex}" 
            :key="index"  
            @click="changebuhanshuwei(item.code)" 
            size="small"
          >{{item.name}}</span>
        </div>
      </div>

    </div>
    <!-- 分隔线 -->
    <div class="divider" @click="upOrdownfunc()">
      <el-divider v-if="upOrdown">收起<i class="el-icon-arrow-up"></i></el-divider>
      <el-divider v-else>展开<i class="el-icon-arrow-down"></i></el-divider>
    </div>
    <!-- 号码列表 -->
    <div class="numberBox">
      <!-- 有号码 -->
      <div class="numberBoxhas" v-if="numberListhas">
        <div class="numberBoxhas_bot" v-loading="numberListLoading">
          <div class="numberBoxhas_bot_item" v-for="(item,index) in numberList" :key="index" @click="gotopackage($event,item.pretty)">
            <div class="numberBoxhas_bot_item_level">{{item.pretty == 1 ? '靓号' : '普号'}}</div>
            <div class="numberBoxhas_bot_item_number">
              <span class="numberBoxhas_bot_item_number_con">{{item.phoneNum}}</span>
              <span v-if="item.actTitle=='抢购专区'"><img src="../../assets/liang.png" alt=""></span>
            </div>
            <div class="numberBoxhas_bot_item_city">{{item.cityName}}</div>
            <div class="numberBoxhas_bot_item_money">￥{{(item.price / 100).toFixed(2)}}</div>
          </div>
        </div>
        <div class="changebatches cursor" @click="changebatchesFunc">
          <span>换一批</span>
        </div>
        <!-- <div class="paginationBox">
          <el-pagination
            background
            @prev-click="prevPage"
            @next-click="nextPage"
            layout=" next"
            next-text="换一批">
          </el-pagination>
        </div> -->
      </div>
      <!-- 没有号码 -->
      <div class="numberBoxNone" v-else>
        <div class="numberBoxNone_img">
          <img src="../../assets/numberboxnone.png" alt="">
        </div>
        <div class="numberBoxNone_desc">暂无更多号码啦～</div>
        <div class="numberBoxNone_desc">请客官试试搜索其他内容吧~</div>
      </div>
    </div>

  </div>
  
</template>

<script>
import { Loading } from 'element-ui';
export default {
  name: "stepOne",
  props: {
    msg: String
  },
  data(){
    return {
      token : window.localStorage.getItem('token'),
      loading : '',
      numberListLoading : false,
      cityDefault:['100','100'],
      provinceCode : '100',
      cityCode: '100',
      cityList: null,
      licknum: '',
      minlength: '4',
      minlengthdesc: '至少输入4位数字',
      maxlength: '11',
      searchWay: {
        searchTitle : '搜索方式',
        searchCon : []
      },
      haoduanSearch: {
        searchTitle : '号段搜索',
        searchCon : []
      },
      haoduanLevel: {
        searchTitle : '号段等级',
        searchCon : []
      },
      specialNum: {
        searchTitle : '特殊靓号',
        searchCon : []
      },
      searchlianghaoList: {
        searchTitle : '高级靓号',
        searchCon : []
      },
      searchpuhaoList:{
        searchTitle : '普通靓号',
        searchCon : []
      },
      priceInterval: {
        searchTitle : '价格区间',
        searchCon : []
      },
      jiaoduoshuwei: {
        searchTitle : '较多数位',
        searchCon : []
      },
      buhanshuwei: {
        searchTitle : '不含数位',
        searchCon : []
      },
      upOrdown: false,
      searchWayIndex : '1',
      haoduanSearchIndex : [],
      haoduanLevelIndex : '0',
      specialNumIndex : '',
      lianghaoCondition : '',
      puhaoCondition : '',
      priceIntervalIndex : '',
      jiaoduoshuweiIndex : '',
      buhanshuweiIndex : '',
      firstId : '0',
      //prevOrNext : '1',
      lastId : '0',
      numberListhas : true,
      numberList : []
    }
  },
  methods: {
    //展开收起
    upOrdownfunc : function (){
      this.upOrdown = !this.upOrdown;
    },
    //搜索条件切换
    changesearchWayIndex : function (index,e) {
      this.searchWayIndex = index;
      if(index == '1'){
        this.minlength = 4;
        this.maxlength = 11;
        this.minlengthdesc = '至少输入4位数字';
      }else{
        this.minlength = 4;
        this.maxlength = 4;
        this.minlengthdesc = '只能输入4位数字';
      }
    },
    changehaoduanSearchIndex : function (indexcode,e) {
      if (e.target.className.indexOf("searchConItemAct") == -1) {
        e.target.className = "searchConItem searchConItemAct"; //切换按钮样式
        this.haoduanSearchIndex.push(indexcode);
      } else {
        e.target.className = "searchConItem";//切换按钮样式
        var that = this;
        this.haoduanSearchIndex.forEach(function(item,index){
          if(item == indexcode){
            that.haoduanSearchIndex.splice(index,1)
          }
        })
      }
    },
    changehaoduanLevelIndex : function (index) {
      this.haoduanLevelIndex = index;
    },
    changespecialNumIndex : function (index) {
      if(index == this.specialNumIndex){
        this.specialNumIndex = '';
      }else{
        this.specialNumIndex = index;
      }
    },
    changelianghaoCondition : function (index) {
      if(index == this.lianghaoCondition){
        this.lianghaoCondition = '';
      }else{
        this.lianghaoCondition = index;
      }
    },
    changepuhaoCondition : function (index) {
      if(index == this.puhaoCondition){
        this.puhaoCondition = '';
      }else{
        this.puhaoCondition = index;
      } 
    },
    changepriceInterval : function (index) {
      if(index == this.priceIntervalIndex){
        this.priceIntervalIndex = '';
      }else{
        this.priceIntervalIndex = index;
      } 
    },
    changejiaoduoshuwei: function (index) {
      if(index == this.jiaoduoshuweiIndex){
        this.jiaoduoshuweiIndex = '';
      }else{
        this.jiaoduoshuweiIndex = index;
      } 
    },
    changebuhanshuwei: function (index) {
      if(index == this.buhanshuweiIndex){
        this.buhanshuweiIndex = '';
      }else{
        this.buhanshuweiIndex = index;
      } 
    },
    //城市切换
    cityChange : function (te) {
      this.provinceCode = te[0];
      this.cityCode = te[1];
      te.map((value,index,array) => {
        for(var i of this.cityList){
          if( i.code == value ){
            let province = i.city;
            for(var j of province){
              if( i.code == value ){
                let shi = i.city;
              }
            }
          }
        }
      })
    },
    searchBtnFun : function(){
      if(this.licknum.length != 0){
        if(this.licknum.length < 4){
          this.$alert('搜索框最少输入4位数字', '提示', {
            confirmButtonText: '确定',
          });
          return;
        }
      }
      this.numberListLoading = true;
      this.lastId = '0',
      this.getNumList()
    },
    getNumList : function(){
      var that = this;
      let phoneTitle = '';
      this.haoduanSearchIndex.forEach(function(item,index){
        phoneTitle += "&"+item;
      })
      phoneTitle = phoneTitle.substr(1);
      if(this.haoduanSearchIndex.length == 3){
        phoneTitle = '';
      }
      if(this.provinceCode == '100'){
        this.cityCode = '100'
      };
      if(this.cityCode !== undefined){
        this.provinceCode = ''
      };
      var datas = {
        "token":this.token,
        'provinceCode':this.provinceCode,
        'cityCode':this.cityCode,
        'phoneSegment':this.licknum,
        'typeSegment':this.searchWayIndex,
        'pretty':this.haoduanLevelIndex,
        'levelOne':this.lianghaoCondition,
        'levelTwo':this.puhaoCondition,
        'levelThr':this.specialNumIndex,
        'levelFou':this.priceIntervalIndex,
        'levelFiv':this.jiaoduoshuweiIndex,
        'levelSix':this.buhanshuweiIndex,
        'phoneTitle':phoneTitle,
        'lastId':this.lastId,
        'pageSize':50,
        'filled':'0'
      }
      this.$http.post('/getSearch',datas,{emulateJSON: true})
      .then(function(res){ 
        var data = res.data;
        if(data.code == '200'){
          if(data.data.list.length){
            that.numberList = data.data.list;
            that.lastId = data.data.list[data.data.list.length-1].sid;
            that.numberListhas = true;
            if(data.data.list.length < 50){
              console.log($('.btn-next').attr('disabled','disabled'))
            }
          }else{
            that.numberListhas = false;
          }
          that.numberListLoading = false;
          that.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            that.loading.close();
          });
        }else{
          that.loading.close();
          that.numberListLoading = false;
          that.$message({
            message: data.msg,
            type: 'error',
            offset: '300'
          });
        }
      }).catch(function(err){ 
        that.loading.close();
        that.numberListLoading = false;
        that.$message({
          message: '号码列表查询失败',
          type: 'error',
          offset: '300'
        });
      }) 
    },
    getdata : function(){
      var datas = {
        "token":this.token,
      };
      var that = this;
      this.$http.post('/getCondition',datas)
      .then(function(res){ 
        var data = res.data;
        if(data.code == '200'){
          that.cityList = data.data.province; //城市列表
          that.cityList.unshift({"code":"100","name":"全国","city":[{"code":"100","name":"全国"}]})
          that.haoduanSearch.searchCon = data.data.phoneTitle.split('&');
          data.data.level.forEach(function(item,index){
            if(item.type == '1'){
              that.searchlianghaoList.searchCon.push(item);
            }else if(item.type == '2'){
              that.searchpuhaoList.searchCon.push(item);
            }else if(item.type == '3'){
              that.specialNum.searchCon.push(item);
            }else if(item.type == '4'){
              that.priceInterval.searchCon.push(item);
            }else if(item.type == '5'){
              that.jiaoduoshuwei.searchCon.push(item);
            }else if(item.type == '6'){
              that.buhanshuwei.searchCon.push(item);
            }
          })
          that.haoduanLevel.searchCon = data.data.pretty;
          that.searchWay.searchCon = data.data.typeSegment;
          that.getNumList();
        }else{
          that.loading.close();
          that.$message({
            message: data.msg,
            type: 'error',
            offset: '300'
          });
        }
      }).catch(function(err){ 
        console.log(err)
        that.loading.close();
        that.$message({
          message: '筛选条件查询失败',
          type: 'error',
          offset: '300'
        });
      }) 
    },
    changebatchesFunc : function() {
      this.numberListLoading = true;
      this.getNumList();
    },
    // getPage : function() {
    //   //const params = {
    //     currentPage: this.currentPage
    //   //};
    // },
    // prevPage : function(val) {
    //   this.numberListLoading = true;
    //   this.prevOrNext = '2',
    //   this.getNumList();
    // },
    // nextPage : function(val) {
    //   this.numberListLoading = true;
    //   this.prevOrNext = '1',
    //   this.getNumList();
    // },
    gotopackage : function(e,pretty){
      let curNumber = e.currentTarget.getElementsByClassName("numberBoxhas_bot_item_number_con")[0].innerHTML;
      let curNumbercity = e.currentTarget.getElementsByClassName("numberBoxhas_bot_item_city")[0].innerHTML;
      this.$emit('curNumberFunc',curNumber,curNumbercity,this.provinceCode,this.cityCode,pretty,1);
    }
  },
  beforeMount : function(){
    this.loading= Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  },
  mounted:function(){
    console.log(this.token)
    this.getdata();
    // this.getPage()
    setInterval(function(){
      document.querySelectorAll('.el-cascader-node__label').forEach(el=>{
        el.onclick = function () {
          this.previousElementSibling.click()
        }
      })
    },500)
  },
  watch:{
    'licknum': function (curVal, oldVal) {
      if (!curVal) {
          this.licknum = ''
          return false
      }
      // 实时把非数字的输入过滤掉
      this.licknum = curVal.match(/\d/ig) ? curVal.match(/\d/ig).join('') : ''
    },
    'cityDefault': function(curVal, oldVal){
      this.$refs.cascader.toggleDropDownVisible()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.stepOne{
  .cursor {
    cursor: pointer;
  }
  .searchCriteria {
    .searchTitle {
      font-size: 16px;
      margin-right: 5px;
      width: 80px;
      line-height: 34px;
      height: 44px;
    }
    .searchCityAndNum {
      color:#303133;
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
      .searchNum {
        display: flex;
      }
    }
    .searchSecondList {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      flex-wrap: wrap;
    }
    .searchSecondItem {
      display: flex;
      .searchConItem {
        display: inline-block;
        padding: 8px 20px;
        text-align: center;
        margin-bottom: 10px;
        margin-right: 10px;
        font-size: 12px;
        border: 1px solid #DCDFE6;
        border-radius: 3px;
      }
    }
    .searchThirdItem {
      display: flex;
      .searchCon {
        flex: 1;
        text-align: left;
        .searchConItem {
          display: inline-block;
          padding: 8px 20px;
          text-align: center;
          margin-bottom: 10px;
          margin-right: 10px;
          font-size: 12px;
          border: 1px solid #DCDFE6;
          border-radius: 3px;
        }
      }
    }
    .el-input {
      margin: 0 10px;
    }
    .el-button+.el-button {
      margin-left: 0;
    }
    .el-button {
      margin-right: 10px;
    }
    .searchConItemAct {
      color: #409eff;
      background: #ecf5ff;
      border-color: #b3d8ff;
    }
  }
  .el-divider__text {
    font-size: 14px;
    color: #606266;
    cursor: pointer;
  }
  .numberBox {
    .numberBoxNone {
      text-align: center;
      padding: 200px 0;
      .numberBoxNone_img {
        width: 210px;
        margin: 0 auto;
        padding-bottom: 10px;
        img {
          width:100%;
        }
      }
      .numberBoxNone_desc {
        font-size: 20px;
        color: #BFBFBF;
        line-height:28px;
      }
    }
    .numberBoxhas {
      text-align: left;
      .numberBoxhas_bot {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .numberBoxhas_bot_item {
          width: 46%;
          display: flex;
          justify-content: space-around;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 16px;
          color: #606266;
          .numberBoxhas_bot_item_level {
            width: 20%;
          }
          .numberBoxhas_bot_item_number {
            width: 30%;
            font-weight:500;
            display: flex;
            align-items: center;
            img{
              width: 15px;
              height: 15px;
              display: block;
              padding-left:10px;
            }
          }
          .numberBoxhas_bot_item_city {
            width: 25%;
          }
          .numberBoxhas_bot_item_money {
            width: 25%;
          }
        }
        .numberBoxhas_bot_item:hover {
          color: #1989FA;
          box-shadow:0px 2px 12px 0px #F7F7F7;
          border-radius:4px;
          border:1px solid #E4E7ED;
          box-sizing: border-box;
          cursor: pointer;
        }
      }
      .changebatches {
        padding-top: 20px;
        text-align: center;
        color: #606266;
        span {
          padding: 8px 20px;
          text-align: center;
          margin-bottom: 10px;
          margin-right: 10px;
          font-size: 16px;
          border: 1px solid #DCDFE6;
          border-radius: 3px;
        }
        span:hover {
          color: #409eff;
          background: #ecf5ff;
        }
      }
    }
  }
}
</style>
